// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Errors/Cyclic_object_value
const getCircularReplacer = () => {
    const seen = new WeakSet();
    return (_, value) => {
        if (typeof value === 'object' && value !== null) {
            if (seen.has(value)) {
                return;
            }
            seen.add(value);
        }
        return value;
    };
};

export const safeStringify = jsonObj => JSON.stringify(jsonObj, getCircularReplacer());

export const get = (object, path, defaultValue) => {
    if (!object) {
        return typeof defaultValue !== 'undefined' ? defaultValue : object;
    }
    let internalObject = object;
    const seg = (path.indexOf('.') !== -1) ? path.split('.') : [path];
    while (internalObject && seg.length) {
        internalObject = internalObject[seg.shift().replace(/[\[\]']+/g, '')];
    }
    return internalObject !== undefined ? internalObject : defaultValue;
};

export const getQueryParam = (out, queryParam) => {
    if (typeof window === 'object') {
        return new URL(window.location.href).searchParams.get(queryParam);
    }
    return get(out, `global.req.query.${queryParam}`);
};

export const isDraft = out => getQueryParam(out, 'draft') === 'true';

export const clone = model => JSON.parse(JSON.stringify(model));

// TODO: Remove once it's determined that leftNav is to be permanent
export const showLeftNav = page => get(page, 'modules.STORE_CATEGORIES_MODULE.showLeftNav', false);
